var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7",
    clipPath: "url(#clip0_373_25417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8335 3.33337V4.16671H3.3335C1.95279 4.16671 0.833496 5.286 0.833496 6.66671V16.6667C0.833496 18.0475 1.95279 19.1667 3.3335 19.1667H16.6668C18.0476 19.1667 19.1668 18.0475 19.1668 16.6667V6.66671C19.1668 5.286 18.0476 4.16671 16.6668 4.16671H14.1668V3.33337C14.1668 1.95267 13.0476 0.833374 11.6668 0.833374H8.3335C6.95279 0.833374 5.8335 1.95267 5.8335 3.33337ZM8.3335 2.50004C7.87326 2.50004 7.50016 2.87314 7.50016 3.33337V4.16671H12.5002V3.33337C12.5002 2.87314 12.1271 2.50004 11.6668 2.50004H8.3335ZM3.3335 5.83337C2.87326 5.83337 2.50016 6.20647 2.50016 6.66671V16.6667C2.50016 17.127 2.87326 17.5 3.3335 17.5H16.6668C17.1271 17.5 17.5002 17.127 17.5002 16.6667V6.66671C17.5002 6.20647 17.1271 5.83337 16.6668 5.83337H3.3335ZM9.16683 9.58337C9.16683 9.35329 9.35341 9.16671 9.5835 9.16671H10.4168C10.6469 9.16671 10.8335 9.35329 10.8335 9.58337V10.8334H12.0835C12.3136 10.8334 12.5002 11.02 12.5002 11.25V12.0834C12.5002 12.3135 12.3136 12.5 12.0835 12.5H10.8335V13.75C10.8335 13.9801 10.6469 14.1667 10.4168 14.1667H9.5835C9.35341 14.1667 9.16683 13.9801 9.16683 13.75V12.5H7.91683C7.68671 12.5 7.50016 12.3135 7.50016 12.0834V11.25C7.50016 11.02 7.68671 10.8334 7.91683 10.8334H9.16683V9.58337ZM9.5835 7.50004C8.56333 7.50004 7.71438 8.23334 7.53506 9.20162C6.5668 9.38096 5.8335 10.2299 5.8335 11.25V12.0834C5.8335 13.1035 6.5668 13.9525 7.53506 14.1318C7.71438 15.1 8.56333 15.8334 9.5835 15.8334H10.4168C11.437 15.8334 12.2859 15.1 12.4652 14.1318C13.4335 13.9525 14.1668 13.1035 14.1668 12.0834V11.25C14.1668 10.2299 13.4335 9.38096 12.4652 9.20162C12.2859 8.23334 11.437 7.50004 10.4168 7.50004H9.5835Z",
    fill: "#CED1D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_25417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeMenu);
export default __webpack_public_path__ + "static/media/EmployeeMenu.4c06759e855168373ec66133087ecf8e.svg";
export { ForwardRef as ReactComponent };